import { SignIn } from '@clerk/clerk-react';
import { useSearchParams } from 'react-router-dom';
import { ArchonIcon } from '@/components/icons/archon-icon';

export default function SignInPage() {
  const basePath = import.meta.env.VITE_BASE_PATH || '';
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect_url');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4 gap-4">

      {/* Logo */}
      <div className="flex flex-col items-center gap-3 mb-1">
        <ArchonIcon className="w-14 h-14 shadow-xl" />
        <div className="font-nunito font-black text-xl text-foreground tracking-tight">Tennis Coach</div>
      </div>

      {/* Clerk Sign In */}
      <SignIn
        fallbackRedirectUrl={redirectUrl ?? `${basePath}/dashboard`}
        appearance={{
          variables: {
            colorBackground: '#FFFFFF',
            colorText: '#111111',
            colorTextSecondary: '#6B6B6B',
            colorInputBackground: '#FFFFFF',
            colorInputText: '#111111',
            colorNeutral: '#6B6B6B',
            colorPrimary: '#E8621A',
            borderRadius: '1rem',
          },
          elements: {
            rootBox: 'w-full flex justify-center',
            card: 'shadow-[0_8px_48px_rgba(0,0,0,0.10)] border border-[#E2E0DA] w-full',
          },
        }}
      />
    </div>
  );
}
